import React from "react";

export default function Bell({
  width = 18,
  height = 19,
  color = "#8B8E9F",
  ...rest
}: {
  width?: number;
  height?: number;
  color?: string;
  [x: string]: any;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4545 1.75736C14.6359 2.88258 15.2996 4.4087 15.2996 6C15.2996 11.2109 17.045 13.651 17.9373 14.558C18.0793 14.7024 17.9636 15 17.7558 15H0.244189C0.0364269 15 -0.0792977 14.7024 0.0627588 14.558C0.954994 13.651 2.70044 11.2109 2.70044 6C2.70044 4.4087 3.36414 2.88258 4.54554 1.75736C5.72694 0.632141 7.32927 0 9.00002 0C10.6708 0 12.2731 0.632141 13.4545 1.75736ZM7.18366 16C6.80817 16 6.46127 16.191 6.27386 16.5009C6.08645 16.8108 6.08706 17.1924 6.27547 17.5018C6.55235 17.9564 6.94977 18.3337 7.42794 18.5961C7.9061 18.8584 8.44823 18.9965 9.00004 18.9965C9.55185 18.9965 10.094 18.8584 10.5721 18.5961C11.0503 18.3337 11.4477 17.9564 11.7246 17.5018C11.913 17.1924 11.9136 16.8108 11.7262 16.5009C11.5388 16.191 11.1919 16 10.8164 16H7.18366Z"
        fill={color}
      />
    </svg>
  );
}
